import { Accordion, AccordionTab } from "primereact/accordion";
import { Toolbar } from "primereact/toolbar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { format } from "date-fns";

import { IPermissionProps } from "../../../models/Login";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { EmptySkillBranchReportFilter, Filter, SkillBranchReportFilter } from "./Filter";
import { Toast } from "primereact/toast";
// import { SubTable } from "./SubTable";
import { SubTableEfficiencyReport } from "../SubTableEfficiencyReport";
import { SubTable } from "./SubTable";
import { SkillSubTableReport } from "./SkillSubTable";



interface IProps {
    permissions: IPermissionProps
}

interface ISkillRecruiterReport {
    login_ID?: number,
    req?: number
}

export const SkillBranchWiseReport = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any, loading: boolean });
    const [skillBranchFilter, setSkillBranchFilter] = useState<SkillBranchReportFilter>(EmptySkillBranchReportFilter);
    const [subTable, setSubTable] = useState({ open: false, resType: 0, catID: 0, branchID: 0, totalRec: null } as { open: boolean, resType: number, catID?: number, branchID?: number, totalRec?: boolean | null });
    const [subTable1, setSubTable1] = useState({ open: false, resType: 0, catID: 0, branchID: 0, totalRec: null } as { open: boolean, resType: number, catID?: number, branchID?: number, totalRec?: boolean | null });
    const [skillSubTable, setSkillSubTable] = useState({ open: false, resType: 0, catID: 0, branchID: 0, totalRec: null } as { open: boolean, resType: number, catID?: number, branchID?: number, totalRec?: boolean | null });

    const [salEffFilter, setSalEffFilter] = useState<SkillBranchReportFilter>(EmptySkillBranchReportFilter);
    const [excelLoading, setExcelLoading] = useState<boolean>(false);
    const [tableLoad, setTableLoad] = useState(false);


    const hideSubTableDialog = () => {
        setSubTable({ open: false, resType: 0, catID: 0, branchID: 0, totalRec: null });
        setSubTable1({ open: false, resType: 0, catID: 0, branchID: 0, totalRec: null });;
        setSkillSubTable({ open: false, resType: 0, catID: 0, branchID: 0, totalRec: null });;
    };


    const dt = useRef<any>();
    const toast = useRef<any>();

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const header = () => {
        return (
            <>Skill Branch Wise Report For Recruiters</>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
            </React.Fragment>
        );
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        //`filter=${JSON.stringify(filters)}`
        const response = await Fetch("Report_Skill_Recruiter", "GET", null, `filter=${JSON.stringify(skillBranchFilter)}`, toast);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const allReq = (rowData: any) => <span onClick={() => setSkillSubTable({ open: true, branchID: rowData.branch_ID || 0, resType: 8, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.req}</span>
    const allReqAllocate = (rowData: any) => <span onClick={() => setSkillSubTable({ open: true, branchID: rowData.branch_ID || 0, resType: 1, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.noofReqAllocate}</span>

    const Serv = (rowData: any) => <span onClick={() => setSubTable({ open: true, branchID: rowData.branch_ID || 0, resType: 5, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.serv}</span>
    const UnServ = (rowData: any) => <span onClick={() => setSubTable({ open: true, branchID: rowData.branch_ID || 0, resType: 6, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.notAll}</span>
    const noOfSubRejSales = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 4, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.sRej}</span>
    const noOfECI = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 7, catID: rowData.req_Category })} className="cursor-pointer text-cyan-700 underline">{rowData.eci}</span>
    const Resume = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID || 0, resType: 1, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.resume}</span>
    const noOfSubClient = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 3, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.ecs}</span>
    const noOfSubRejPV = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 5, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.pvr}</span>
    const noRoomForECS = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 14, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.noAddECS}</span>
    const reqHoldByPV = (rowData: any) => <span onClick={() => setSubTable1({ open: true, branchID: rowData.branch_ID, resType: 15, catID: rowData.req_Category || 0 })} className="cursor-pointer text-cyan-700 underline">{rowData.reqHoldPV}</span>

    const downloadExcel = async (exceltype: number) => {
        setExcelLoading(p => p = true);
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Report_Skill_Recruiter/getexcel"}?` + `filter=` + encodeURIComponent(JSON.stringify(skillBranchFilter)) + `&exceltype=${exceltype}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `SkillBranchwiseReport.xlsx`;
                a.href = href;
                a.click();
                a.href = '';
                setExcelLoading(p => p = false);
            } else if (response.status === 400) {
                const message = await response.text();
                toast.current.show({ severity: 'error', detail: message, life: 3000 });
                setExcelLoading(p => p = false);
            }
        } catch {
            setExcelLoading(p => p = false);
            toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }




    useEffect(() => {
        if(tableLoad){
        loadTableData();
        setTableLoad(false)
        }
    }, [skillBranchFilter]);

    return (
        <>
            {permissions.is_View && <React.Fragment>
                <Toolbar className="mb-1 py-0" left={() => <></>} right={rightToolbarTemplate}></Toolbar>
                <Accordion>
                    <AccordionTab header="Filter">
                        <Filter skillBranchFilter={skillBranchFilter} setSkillBranchFilter={setSkillBranchFilter} downloadExcel={downloadExcel} excelLoading={excelLoading} onSearch={() => setTableLoad(true)}/>
                    </AccordionTab>
                </Accordion>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines scrollable responsiveLayout="scroll" scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.tableData}
                    resizableColumns
                    emptyMessage="No Requirements found."
                    header={header}
                    loading={tableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={() => { return <span className="font-bold" onClick={() => { }}>Total</span> }} />
                    <Column field="company_name" sortable header="Company" />
                    <Column field="branchName" header="Branch" />
                    <Column field="req_CategoryName" header="Skill Category" style={{ maxWidth: "8rem", overflow: "hidden" }} />
                    <Column field="noofReqAllocate" header="Reqs" sortable body={allReqAllocate}
                        footer={() => {
                            const Reqall = tableData.tableData.reduce((sum: any, item: { noofReqAllocate: any; }) => sum + (item.noofReqAllocate || 0), 0);
                            return <span
                                onClick={() => setSkillSubTable({ open: true, resType: 1, totalRec: true })}
                                className="cursor-pointer text-cyan-700 underline"
                            >{Reqall}</span>;
                        }} />
                    <Column field="req" header="Allocated Recruiters" sortable body={allReq}
                        footer={() => {
                            const Req = tableData.tableData.reduce((sum: any, item: { req: any; }) => sum + (item.req || 0), 0);
                            return <span
                                onClick={() => setSubTable({ open: true, resType: 1, totalRec: true })}
                                className="cursor-pointer text-cyan-700 underline"
                            >{Req}</span>;
                        }} />

                    <Column field="resume" header="Resume" sortable body={Resume}
                        footer={() => {
                            const Resume = tableData.tableData.reduce((sum: any, item: { resume: any; }) => sum + (item.resume || 0), 0);
                            return <span
                                onClick={() => setSubTable1({ open: true, resType: 1, totalRec: true })}
                                className="cursor-pointer text-cyan-700 underline"
                            >{Resume}</span>;
                        }} />
                    <Column field="serv" header="Serv" sortable body={Serv}
                        footer={() => {
                            const Serve = tableData.tableData.reduce((sum: any, item: { serv: any; }) => sum + (item.serv || 0), 0);
                            return <span
                                onClick={() => setSubTable({ open: true, resType: 5, totalRec: true })}
                                className="cursor-pointer text-cyan-700 underline"
                            >{Serve}</span>;
                        }} />
                    <Column field="serv_Per" header="Serv(%)" sortable
                        footer={() => {
                            const Totalserved = tableData.tableData.reduce((sum: any, item: { serv: any; }) => sum + (item.serv || 0), 0);
                            const TotalReq = tableData.tableData.reduce((sum: any, item: { req: any; }) => sum + (item.req || 0), 0);
                            const percentage: number = (Totalserved * 100 / TotalReq);
                            return <span>
                                {percentage ? percentage.toFixed(1) : 0}
                            </span>
                        }}
                    />
                    <Column field="notAll" sortable header="UnAll" body={UnServ}
                        footer={() => {
                            const NotAll = tableData.tableData.reduce((sum: any, item: { notAll: any; }) => sum + (item.notAll || 0), 0);
                            return <span
                                onClick={() => setSubTable({ open: true, resType: 6, totalRec: true })}
                                className="cursor-pointer text-cyan-700 underline"
                            >{NotAll}</span>;
                        }} />
                    <Column field="sRej" sortable header="SRej" body={noOfSubRejSales}
                        footer={() => {
                            const SRej = tableData.tableData.reduce((sum: any, item: { sRej: any; }) => sum + (item.sRej || 0), 0);
                            return <span
                                onClick={() => setSubTable1({ open: true, resType: 4, totalRec: true })}
                                className="cursor-pointer text-cyan-700 underline"
                            >{SRej}</span>;
                        }} />
                    <Column field="pvr" header="PVR" body={noOfSubRejPV}
                        footer={() => {
                            const Pvr = tableData.tableData.reduce((sum: any, item: { pvr: any; }) => sum + (item.pvr || 0), 0);
                            return <span
                                onClick={() => setSubTable1({ open: true, resType: 5, totalRec: true })}
                                className="cursor-pointer text-cyan-700 underline"
                            >{Pvr}</span>;
                        }} />
                    <Column field="ecs" header="ECS" body={noOfSubClient}
                        footer={() => {
                            const ECS = tableData.tableData.reduce((sum: any, item: { ecs: any; }) => sum + (item.ecs || 0), 0);
                            return <span
                                onClick={() => setSubTable1({ open: true, resType: 3, totalRec: true })}
                                className="cursor-pointer text-cyan-700 underline"
                            >{ECS}</span>;
                        }} />
                    <Column field="eci" header="ECI" body={noOfECI}
                        footer={() => {
                            const ECI = tableData.tableData.reduce((sum: any, item: { eci: any; }) => sum + (item.eci || 0), 0);
                            return <span
                                onClick={() => setSubTable1({ open: true, resType: 7, totalRec: true })}
                                className="cursor-pointer text-cyan-700 underline"
                            >{ECI}</span>;
                        }} />
                    <Column field="po" header="PO"
                        footer={() => {
                            const PO = tableData.tableData.reduce((sum: any, item: { po: any; }) => sum + (item.po || 0), 0);
                            return <span className="font-bold">{PO}</span>;
                        }} />
                    <Column field="noAddECS" header="NoRoomECS" body={noRoomForECS}
                        footer={() => {
                            const noAddECS = tableData.tableData.reduce((sum: any, item: { noAddECS: any; }) => sum + (item.noAddECS || 0), 0);
                            return <span className="font-bold">{noAddECS}</span>;
                        }} />
                    <Column field="reqHoldPV" header="ReqHoldPV" body={reqHoldByPV}
                        footer={() => {
                            const reqHoldPV = tableData.tableData.reduce((sum: any, item: { reqHoldPV: any; }) => sum + (item.reqHoldPV || 0), 0);
                            return <span className="font-bold">{reqHoldPV}</span>;
                        }} />
                </DataTable>
                <SkillSubTableReport open={skillSubTable.open} catID={skillSubTable.catID} branchID={skillSubTable.branchID} resType={skillSubTable.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={skillBranchFilter} recType={'branchWise'} totalRec={skillSubTable.totalRec} />

                <SubTableEfficiencyReport open={subTable.open} catID={subTable.catID} branchID={subTable.branchID} resType={subTable.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={skillBranchFilter} recType={'branchWise'} totalRec={subTable.totalRec} />
                <SubTable open={subTable1.open} catID={subTable1.catID} branchID={subTable1.branchID} resType={subTable1.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={skillBranchFilter} totalRec={subTable1.totalRec} recType={'branchWise'} />
            </React.Fragment>}
            <Toast ref={toast} />
        </>
    );
}